define(['app/helpers/helpers'], function (helpers) {
    function TagManager() {
        if (partyking.dev == 1) {
            return;
        }

        const tagId = 'GTM-WS9RC7HC';

        const events = {
            otherPages: 'other_pages',
            landingPage: 'landing_page',
            pageView: 'page_view',
            productView: 'product_view',
            addToCart: 'add_to_cart',
            addToCartFromCard: 'add_to_cart_from_card',
            addToCartFromAccessory: 'add_to_cart_from_accessory',
            removeFromCart: 'remove_from_cart',
            search: 'search',
            autoComplete: 'auto_complete',
            searchClick: 'search_click',
            purchase: 'purchase',
            buy: 'buy', //raptor purchase event per product
            categoryView: 'category_view',
            newOffers: 'new_offers',
            sales: 'sales',
            wishList: 'wish_list',
            favorite: 'favorite',
            viewCart: 'view_cart',
            beginCheckout: 'begin_checkout',
            addShippingInfo: 'add_shipping_info',
            selectItem: 'select_item',
            basket: 'basket',
            contentView: 'content_view',
            itemClick: 'item_click',
            balloonClick: 'balloon_click',
        };

        const serverSideEndpoints = {
            pinterest: '/track/pinterest',
            facebook: '/track/facebook',
        };

        const pinterestServerEvents = new Map([
            [events.pageView, 'page_visit'],
            [events.addToCart, 'add_to_cart'],
            [events.purchase, 'checkout'],
            [events.search, 'search'],
            [events.categoryView, 'view_category'],
        ]);

        const facebookServerEvents = new Map([
            [events.pageView, 'PageView'],
            [events.addToCart, 'AddToCart'],
            [events.purchase, 'Purchase'],
            [events.productView, 'ViewContent'],
        ]);

        // This variable is used to check if we are on a page that is not one of the pages bellow
        // If the page is not in the array we trigger the other_pages event
        const pagesToExcludeForOtherPages = ['index', 'checkoutPage', 'orderPage', 'productPage', 'categoryPage'];

        const eventHandlers = {
            landingPage: () => {
                const eventData = {
                    rtbHouse: {},
                };
                track(events.landingPage, eventData);
            },
            pageView: () => {
                const eventData = {
                    pinterest: {},
                    facebook: {},
                };

                track(events.pageView, eventData);

                if (window.profitMetrics !== undefined) {
                    window.profitMetrics.pageViewGeneric();
                }
            },
            productView: (product) => {
                const firstStock = product.product_stocks[0];
                const productId = product.id;
                const priceNoVat = product.minprice.value / 100;
                const currency = partyking.config.currency.currency;
                const category = product.product_categories.length ? product.product_categories[0].name : '';

                const id = typeof firstStock === 'undefined' ? `${productId}-1` : `${productId}-${firstStock.id}`;
                const name =
                    typeof firstStock === 'undefined' ? product.name : `${product.name} - ${firstStock.alternative}`;

                const value = Math.round(
                    (product.minprice.value * (1 + parseFloat(product.minprice.vat / 100))) / 100
                ).toFixed(product.minprice.precision);

                const hash = window.location.hash.replace('#', '');
                let raptorProductId = productId;
                let raptorPrice =
                    product.mincurrentprice.value_incl_vat /
                    parseInt('1' + '0'.repeat(product.mincurrentprice.precision));
                let instock = product.instock > 0;

                if (hash) {
                    const id = hash.substring(hash.lastIndexOf('-') + 1, hash.length);
                    const variant = product.variants.find((variant) => variant.id == id);
                    if (variant) {
                        if (variant.saleprice.value_incl_vat > 0) {
                            raptorPrice =
                                variant.saleprice.value_incl_vat /
                                parseInt('1' + '0'.repeat(variant.value_incl_vat.precision));
                        } else {
                            raptorPrice =
                                variant.price.value_incl_vat / parseInt('1' + '0'.repeat(variant.price.precision));
                        }
                        instock = variant.instock > 0;
                    }
                }
                const eventData = {
                    facebook: {
                        content_ids: [id],
                        content_type: 'product',
                        value: value,
                        currency,
                    },
                    pinterest: {
                        content_ids: [productId.toString()],
                        value: priceNoVat.toString(),
                        currency,
                    },
                    rtbHouse: {
                        product_id: productId.toString(),
                    },
                    googleAds: {
                        value: priceNoVat,
                        items: [
                            {
                                id,
                                google_business_vertical: 'retail',
                            },
                        ],
                    },
                    googleAnalytics: {
                        currency,
                        value: priceNoVat,
                        items: [
                            {
                                item_id: id,
                                item_name: name,
                                item_category: category,
                                item_brand: '',
                                item_variant: firstStock?.alternative || id,
                                price: priceNoVat,
                                quantity: 1,
                            },
                        ],
                    },
                    raptor: {
                        ProductId: raptorProductId.toString(),
                        ProductName: product.name,
                        CategoryPath: product.category_path,
                        BrandId: product.brand,
                        ItemPrice: raptorPrice,
                        StockStatus: instock,
                        MasterId: productId.toString(),
                        Currency: currency,
                    },
                };

                track(events.productView, eventData);
                track(events.pageView, eventData);

                if (window.profitMetrics !== undefined) {
                    window.profitMetrics.pageViewProduct(id, name);
                }
            },
            addToCart: (productData) => {
                const shoppingcart = partyking.common.models.shoppingcart;

                const cartItem = productData.cartItem;
                const currency = partyking.config.currency.currency;
                const value = cartItem.totals.perPieceNoVat.toString();
                const id = cartItem.data.productid.toString();
                const name =
                    cartItem.data.alternative !== ''
                        ? `${cartItem.name} - ${cartItem.data.alternative}`
                        : cartItem.name;

                const alternative = cartItem.data.productid + '-' + cartItem.data.id;
                const quantity = cartItem.quantity;
                const category = cartItem.data.belongs_to_product.category || '';
                const brand = cartItem.data.belongs_to_product.brand || '';

                const productIds = shoppingcart.productIdsAsString();

                const eventData = {
                    facebook: {
                        content_type: 'product',
                        content_ids: [alternative],
                        value: parseFloat(cartItem.displayTotals.perPiece),
                        currency,
                    },
                    pinterest: {
                        currency,
                        value,
                        content_ids: [id],
                    },
                    rtbHouse: {
                        product_id: id,
                    },
                    googleAds: {
                        value: parseFloat(value) * (quantity || 1),
                        items: [
                            {
                                id: alternative,
                                google_business_vertical: 'retail',
                            },
                        ],
                    },
                    googleAnalytics: {
                        currency,
                        value: parseFloat(value) * (quantity || 1),
                        items: [
                            {
                                item_id: id,
                                item_name: name,
                                item_category: category,
                                item_brand: brand,
                                item_variant: alternative,
                                price: parseFloat(value),
                                quantity: quantity || 1,
                            },
                        ],
                    },
                    blue: {
                        productIds,
                    },
                };

                track(events.addToCart, eventData);
                eventHandlers.basket(cartItem);

                if (window.profitMetrics !== undefined) {
                    window.profitMetrics.addToCart([
                        {
                            id: alternative,
                            quantity,
                            name,
                            price: parseFloat(value),
                        },
                    ]);
                }

                if (productData.source === 'product-grid') {
                    track(events.addToCartFromCard, { googleAnalytics: eventData.googleAnalytics });
                } else if (productData.source === 'accessory') {
                    track(events.addToCartFromAccessory, { googleAnalytics: eventData.googleAnalytics });
                }
            },
            removeFromCart: (data) => {
                const cartItem = data.cartItem;
                const value = cartItem.totals.perPieceNoVat;
                const id = cartItem.data.productid.toString();
                const name =
                    cartItem.data.alternative !== ''
                        ? `${cartItem.name} - ${cartItem.data.alternative}`
                        : cartItem.name;

                const alternative = cartItem.data.productid + '-' + cartItem.data.id;
                const quantity = cartItem.quantity;
                const category = cartItem.data.belongs_to_product.category || '';
                const brand = cartItem.data.belongs_to_product.brand || '';
                const currency = partyking.config.currency.currency;

                const eventData = {
                    googleAnalytics: {
                        currency,
                        value: parseFloat(value) * (quantity || 1),
                        items: [
                            {
                                item_id: id,
                                item_name: name,
                                item_category: category,
                                item_brand: brand,
                                item_variant: alternative,
                                price: parseFloat(value),
                                quantity: quantity || 1,
                            },
                        ],
                    },
                };

                track(events.removeFromCart, eventData);
                eventHandlers.basket(cartItem);
            },
            basket: (cartItem) => {
                const shoppingcart = partyking.common.models.shoppingcart;
                const productId = cartItem.key;
                const masterId = cartItem.data.belongs_to_product.id.toString();
                const productIds = shoppingcart
                    .getProducts()
                    .map((cartItem) => cartItem.key)
                    .join(',');
                const name = cartItem.name;
                const basketId = shoppingcart.cartId;
                const eventData = {
                    raptor: {
                        ProductId: productId,
                        MasterId: masterId,
                        BasketContent: productIds,
                        ItemPrice: parseFloat(cartItem.totals.perPiece),
                        Name: name,
                        BasketId: basketId,
                    },
                };

                track(events.basket, eventData);
            },
            search: (data) => {
                const searchTerm = partyking.term;
                const products = data.products[0] || [];

                const sliceOfProductIds = products.slice(0, 5).map((product) => product._source.id.toString());
                let value = 0;
                const googleAdsItems = [];
                for (const product of products) {
                    value += product._source.minprice.value / 100;
                    let articleNumber = `${product._source.id}-1`;
                    if (product._source.article_numbers.length > 0) {
                        articleNumber = product._source.article_numbers[0];
                    }

                    googleAdsItems.push({
                        id: articleNumber,
                        google_business_vertical: 'retail',
                    });
                }

                const eventData = {
                    pinterest: {
                        search_string: searchTerm,
                    },
                    rtbHouse: {
                        product_ids: sliceOfProductIds,
                    },
                    googleAds: {
                        value,
                        items: googleAdsItems,
                    },
                    googleAnalytics: {
                        search_term: searchTerm,
                    },
                    raptor: {
                        SearchResult: sliceOfProductIds.join(','),
                    },
                };

                track(events.search, eventData);
            },
            autoComplete: (searchTerm) => {
                const eventData = {
                    raptor: {
                        SearchPhrase: searchTerm,
                    },
                };

                track(events.autoComplete, eventData);
            },
            searchClick: (product) => {
                const eventData = {
                    raptor: {
                        ProductId: product.id.toString(),
                    },
                };

                track(events.searchClick, eventData);
            },
            itemClick: (data) => {
                const { productId, moduleName, redirectUrl } = data;
                const eventData = {
                    ProductId: productId,
                    ModuleName: moduleName,
                };

                track(events.itemClick, eventData, redirectUrl);
            },
            balloonClick: (data) => {
                const { count } = data;
                const eventData = {
                    count,
                };

                track(events.balloonClick, eventData);
            },
            purchase: () => {
                if (partyking.analytics != 0) {
                    return;
                }

                const orderInformation = document.getElementById('order-information');
                const content_ids = Array.from(orderInformation.querySelectorAll('div')).map((el) =>
                    el.getAttribute('data-artno')
                );

                const product_ids = Array.from(orderInformation.querySelectorAll('div')).map((el) =>
                    el.getAttribute('data-id').toString()
                ); // We are using product ids and not article numbers for rtbhouse

                const googleAdsItems = content_ids.map((articleNumber) => {
                    return {
                        id: articleNumber,
                        google_business_vertical: 'retail',
                    };
                });

                const taxes = new Map();
                const products = Array.from(orderInformation.querySelectorAll('div')).map((element) => {
                    const product = {};
                    product.sku = element.getAttribute('data-artno');
                    product.qty = element.getAttribute('data-quantity');
                    product.priceExVat = parseFloat(element.getAttribute('data-pricenovat').replace(',', '.'));

                    const priceIncVat = parseFloat(element.getAttribute('data-price').replace(',', '.'));
                    const taxPercentage = priceIncVat / product.priceExVat;

                    if (!taxes.get(taxPercentage)) {
                        taxes.set(taxPercentage, []);
                    }

                    taxes.set(taxPercentage, [
                        ...taxes.get(taxPercentage),
                        {
                            quantity: product.qty,
                            taxPercentage,
                            priceIncVat,
                            priceExclVat: product.priceExVat,
                        },
                    ]);

                    return product;
                });

                const value = parseFloat($('#order-information').data('subtotal-excl-taxes').replace(',', '.'));
                const priceInclVat = parseFloat(orderInformation.getAttribute('data-value').replace(',', '.'));
                const taxValue = parseFloat(orderInformation.getAttribute('data-taxes').replace(',', '.'));
                const priceExclVat = priceInclVat - taxValue;
                const shippingPrice = parseFloat(orderInformation.getAttribute('data-shipping').replace(',', '.'));
                const order_id = orderInformation.getAttribute('data-id');
                const currency = partyking.config.currency.currency;
                const priceShippingExVat = removeVatFromShipping(shippingPrice, taxes);
                const couponCode = orderInformation.getAttribute('data-discountcode') || '';
                const email = orderInformation.getAttribute('data-email') || '';

                const md5 = helpers.md5(email.trim().toLocaleLowerCase());

                const googleItems = Array.from(orderInformation.querySelectorAll('div')).map((element) => {
                    return {
                        id: element.getAttribute('data-artno'),
                        name: element.getAttribute('data-name'),
                        brand: '',
                        affiliation: 'Partyking',
                        category: '',
                        variant: element.getAttribute('data-variant'),
                        quantity: element.getAttribute('data-quantity'),
                        price: parseFloat(element.getAttribute('data-pricenovat').replace(',', '.')),
                    };
                });

                const eventData = {
                    adtraction: {
                        transactionId: order_id,
                        transactionTotal: value,
                        transactionPromoCode: couponCode,
                        currency,
                        md5,
                    },
                    pinterest: {
                        content_ids,
                        value: value.toString(),
                        currency,
                        order_id: order_id.toString(),
                        num_items: content_ids.length,
                    },
                    facebook: {
                        content_ids,
                        content_type: 'product',
                        value,
                        currency,
                    },
                    google_conversion: {
                        transaction_id: order_id,
                        affiliation: 'Partyking',
                        value,
                        currency,
                    },
                    googleAds: {
                        value,
                        items: googleAdsItems,
                    },
                    rtbHouse: {
                        conversion_id: order_id,
                        content_ids: product_ids,
                        conversion_value: value,
                        currency,
                    },
                    blue: {
                        productIds: product_ids.join(','),
                    },
                    bing: {
                        revenue_value: value,
                        currency,
                        transaction_id: order_id,
                    },
                    profitMetrics: {
                        id: order_id,
                        currency: currency,
                        priceTotalExVat: priceExclVat,
                        priceTotalInclVat: priceInclVat,
                        priceShippingExVat,
                        products: products,
                    },
                    googleAnalytics: {
                        transaction_id: order_id,
                        currency,
                        value: priceExclVat,
                        shipping: priceShippingExVat,
                        tax: taxValue,
                        items: googleItems,
                    },
                };

                track(events.purchase, eventData);
                eventHandlers.buy(orderInformation);
            },
            buy: (orderInformation) => {
                const currency = orderInformation.getAttribute('data-currency');
                for (const productDiv of orderInformation.querySelectorAll('div')) {
                    const productId = productDiv.getAttribute('data-id');
                    const sku = productDiv.getAttribute('data-artno');
                    let productName = productDiv.getAttribute('data-name');
                    const variant = productDiv.getAttribute('data-variant');
                    const price = parseFloat(productDiv.getAttribute('data-price').replace(',', '.'));
                    const quantity = parseFloat(productDiv.getAttribute('data-quantity'));
                    const subtotal = price * quantity;
                    const categoryPath = productDiv.getAttribute('data-category-path');

                    if (variant) {
                        productName = `${productName} ${variant}`;
                    }

                    const eventData = {
                        raptor: {
                            ProductId: productId,
                            ProductName: productName,
                            Subtotal: subtotal,
                            Currency: currency,
                            ItemPrice: price,
                            MasterId: productId,
                            Quantity: quantity,
                            CategoryPath: categoryPath,
                        },
                    };

                    track(events.buy, eventData);
                }
            },
            categoryView: (data) => {
                const categoryName = data.category.name.toString();
                const categoryId = data.category.id;

                const items = [];
                const googleAdsItems = [];
                let value = 0;
                let index = 0;
                for (const products of data.products) {
                    for (const product of products) {
                        index++;
                        value += product._source.minprice.value / 100;
                        items.push({
                            id: product._source.id,
                            name: product._source.name,
                            brand: '',
                            category: data.category.name,
                            variant: '',
                            price: product._source.minprice.value / 100,
                            list_position: index,
                        });

                        let articleNumber = `${product._source.id}-1`;

                        if (product._source.article_numbers.length > 0) {
                            articleNumber = product._source.article_numbers[0];
                        }

                        googleAdsItems.push({
                            id: articleNumber,
                            google_business_vertical: 'retail',
                        });
                    }
                }

                const eventData = {
                    pinterest: {
                        content_name: categoryName,
                    },
                    rtbHouse: {
                        category_id: categoryId,
                    },
                    googleAds: {
                        value,
                        items: googleAdsItems,
                    },
                    googleAnalytics: {
                        item_list_id: 'category_' + data.category.link,
                        item_list_name: 'Category: ' + data.category.name,
                        items: items,
                    },
                };

                track(events.categoryView, eventData);
                if (window.profitMetrics !== undefined) {
                    window.profitMetrics.pageViewCategory(categoryName);
                }
            },
            newOffers() {
                track(events.newOffers);
            },
            sales() {
                track(events.sales);
            },
            wishList(data) {
                const { product, productWasAdded } = data;
                if (!product || !product.id) {
                    return;
                }

                if (productWasAdded) {
                    const currency = partyking.config.currency.currency;
                    const value = product.minprice.value / 100;
                    const name = product.name;
                    const id = product.id;

                    const eventData = {
                        rtbHouse: {
                            product_id: product.id.toString(),
                        },
                        googleAnalytics: {
                            currency,
                            value,
                            items: [
                                {
                                    item_id: id,
                                    item_name: name,
                                    price: value,
                                },
                            ],
                        },
                    };

                    track(events.wishList, eventData);
                }

                eventHandlers.favorite(product);
            },
            favorite(product) {
                const productId = product.id;
                const price = product.mincurrentprice.value_incl_vat / 100;
                const productIds = partyking.common.models.favouriteProducts.products
                    .map((product) => product.id)
                    .join(',');

                const eventData = {
                    raptor: {
                        ProductId: productId,
                        ItemPrice: price,
                        FavoriteListContent: productIds,
                    },
                };

                track(events.favorite, eventData);
            },
            viewCart(data) {
                const cartItems = data.cartItems || [];
                const productIds = cartItems.map((cartItem) => cartItem.data.productid.toString());

                const currency = partyking.config.currency.currency;
                const value = data.totals.subTotal;
                const items = cartItems.map(cartItemToGoogleItem);

                const productIdsAsString = shoppingcart.productIdsAsString();

                if (!productIds.length) {
                    return;
                }
                const eventData = {
                    rtbHouse: {
                        product_ids: productIds,
                    },
                    googleAnalytics: {
                        currency,
                        value,
                        items,
                    },
                    blue: {
                        productIds: productIdsAsString,
                    },
                };

                track(events.viewCart, eventData);
            },
            beginCheckout() {
                const shoppingcart = partyking.common.models.shoppingcart;

                const currency = partyking.config.currency.currency;
                const value = shoppingcart.totals.subTotalNoVat;
                const items = shoppingcart.getProducts().map(cartItemToGoogleItem);

                const eventData = {
                    currency,
                    value,
                    items,
                };

                track(events.beginCheckout, eventData);
            },
            otherPages() {
                const eventData = {
                    rtbHouse: {},
                };
                track(events.otherPages, eventData);
            },
            addShippingInfo(data) {
                const currency = partyking.config.currency.currency;
                const value = shoppingcart.totals.subTotalNoVat;
                const name = data.name || '';
                const items = shoppingcart.getProducts().map(cartItemToGoogleItem);

                const eventData = {
                    googleAnalytics: {
                        currency,
                        value,
                        shipping_tier: name,
                        items,
                    },
                };

                track(events.addShippingInfo, eventData);
            },
            selectItem(data) {
                const cartItem = data.article;
                const collection = data.collection;
                const value = cartItem.price.value / 100;
                const id = cartItem.productid.toString();
                const name =
                    cartItem.alternative !== ''
                        ? `${cartItem.belongs_to_product.name} - ${cartItem.alternative}`
                        : cartItem.belongs_to_product.name;

                const alternative = cartItem.productid + '-' + cartItem.id;
                const quantity = 1; // warning, we might have to change things here later
                const category = cartItem.belongs_to_product.category || '';
                const brand = cartItem.belongs_to_product.brand || '';

                const item_list_id = `collection_${collection.id}`;
                const item_list_name = `collection_${collection.name.replaceAll(' ', '_')}`;

                const eventData = {
                    googleAnalytics: {
                        item_list_id,
                        item_list_name,
                        items: [
                            {
                                item_id: id,
                                item_name: name,
                                item_category: category,
                                item_brand: brand,
                                item_variant: alternative,
                                price: parseFloat(value),
                                quantity: quantity || 1,
                            },
                        ],
                    },
                };

                track(events.selectItem, eventData);
                eventHandlers.addToCart({
                    cartItem: data.article,
                    quantity,
                });
            },
            contentView() {
                const cmsData = document.getElementById('cms-data');
                const contentId = cmsData.getAttribute('data-id');

                const eventData = {
                    raptor: {
                        ContentId: contentId,
                    },
                };

                track(events.contentView, eventData);
            },
        };

        function removeVatFromShipping(shipping, taxMap) {
            if (shipping === 0) {
                return shipping;
            }

            let maxVat = 1;
            for (const [vat, _] of taxMap) {
                if (vat > maxVat) {
                    maxVat = vat;
                }
            }

            return shipping / maxVat;
        }

        function handlePages() {
            switch (partyking.jsEntry) {
                case 'index': {
                    eventHandlers.landingPage();
                    eventHandlers.pageView();
                    break;
                }
                case 'orderPage': {
                    eventHandlers.purchase();
                    break;
                }
                case 'productPage':
                    break;
                case 'checkoutPage': {
                    eventHandlers.beginCheckout();
                    eventHandlers.pageView();
                    break;
                }
                case 'inspiration':
                case 'inspirasjon': {
                    eventHandlers.contentView();
                    eventHandlers.pageView();
                    break;
                }
                default: {
                    eventHandlers.pageView();
                }
            }
        }

        function handleOtherPages() {
            if (!pagesToExcludeForOtherPages.includes(partyking.jsEntry)) {
                eventHandlers.otherPages();
            }
        }

        function handleEvents() {
            partyking.common.on('productAdded', eventHandlers.addToCart);
            partyking.common.on('productRemoved', eventHandlers.removeFromCart);
            partyking.common.on('productPageLoaded', eventHandlers.productView);
            partyking.common.on('categoryPageLoaded', (data) => {
                if (partyking.category_id > 0) {
                    eventHandlers.categoryView(data);
                } else if (partyking.url.includes('/search/')) {
                    eventHandlers.search(data);
                } else if (partyking.url.includes('/hela-sortimentet/') && partyking.sort == 'date_desc') {
                    eventHandlers.newOffers();
                } else if (partyking.url.includes('/outlet/')) {
                    eventHandlers.sales();
                }
            });
            partyking.common.on('miniCartOpened', eventHandlers.viewCart);
            partyking.common.on('favouriteUpdated', eventHandlers.wishList);
            partyking.common.on('shippingOptionChanged', eventHandlers.addShippingInfo);
            partyking.common.on('collectionProductAdded', eventHandlers.selectItem);
            partyking.common.on('autoComplete', eventHandlers.autoComplete);
            partyking.common.on('searchClick', eventHandlers.searchClick);
            partyking.common.on('itemClick', eventHandlers.itemClick);
            partyking.common.on('footerBalloonClicked', eventHandlers.balloonClick);
        }

        function init() {
            try {
                handlePages();
                handleEvents();
                handleOtherPages();
            } catch (error) {
                if (typeof Bugsnag !== 'undefined' && Bugsnag && Bugsnag.notify) {
                    Bugsnag.notify(error);
                }
            }
        }

        function track(event, data = {}, redirectUrl = '') {
            const eventId = helpers.uuid();
            const orderInfo = $('#order-information');
            const jsData = { ...data };

            const email = orderInfo.data('email');
            if (email) {
                const sha256Hashed = helpers.sha256(email.toLowerCase());
                jsData.em = sha256Hashed;
            }

            const eventObj = {
                send_to: tagId,
                event_id: eventId,
                ...jsData,
            };

            if (redirectUrl) {
                eventObj.event_callback = () => (window.location.href = redirectUrl);
            }

            gtag('event', `GTM_${event}`, eventObj);

            const pinterestServerEvent = pinterestServerEvents.get(event);
            const facebookServerEvent = facebookServerEvents.get(event);

            if (pinterestServerEvent) {
                const dataForServerSide = pinterestData(pinterestServerEvent, data.pinterest, eventId, orderInfo);
                serverSide(serverSideEndpoints.pinterest, dataForServerSide);
            }

            if (facebookServerEvent) {
                const dataForServerSide = facebookData(facebookServerEvent, data.facebook, eventId, orderInfo);
                serverSide(serverSideEndpoints.facebook, dataForServerSide);
            }
        }

        function pinterestData(eventName, data, eventId, orderInfo) {
            const outData = {
                event_name: eventName,
                action_source: 'web',
                email: orderInfo.data('email') || '',
                phone_number: orderInfo.data('from-mobilenumber') || '',
                first_name: orderInfo.data('from-firstname') || '',
                last_name: orderInfo.data('from-lastname') || '',
                event_id: eventId,
                event_source_url: document.location.href,
                custom_data: data,
            };

            return outData;
        }

        function facebookData(eventName, data, eventId, orderInfo) {
            const outData = {
                facebook: {
                    name: eventName,
                    data: data,
                    email: orderInfo.data('email') || '',
                    phone_number: orderInfo.data('from-mobilenumber') || '',
                    first_name: orderInfo.data('from-firstname') || '',
                    last_name: orderInfo.data('from-lastname') || '',
                    url: document.location.href,
                    eid: eventId,
                },
            };

            return outData;
        }

        function serverSide(endpoint, data) {
            navigator.sendBeacon(endpoint, JSON.stringify(data));
        }

        function cartItemToGoogleItem(cartItem) {
            return {
                item_id: cartItem.data.productid,
                item_name: cartItem.data.belongs_to_product.name,
                item_variant: cartItem.data.alternative.toString().replace(/ \-.*$/, ''),
                price: parseFloat(cartItem.totals.perPieceNoVat),
                quantity: cartItem.quantity,
            };
        }

        init();
    }

    return TagManager;
});
